import wraparoundNew from "../../../TMAd/js/wraparoundNew.js";
import { init as initCustomDOMEvents } from "./customEvents.js";
import { logFeature } from "../../../scriptsCore/js/logging.js";
import * as nested from "nested-property";

const Site = {
  IN_YOUR_AREA: "iya",
};

const siteConfigIYA = {
  selectors: {
    wraparoundBody: "body",
    topSlot: ".banner-ad-wrapper",
    contentArea: "#site-main > .inner",
    header: "header",
  },
  layout: {
    topAdAboveHeader: false,
  },
  site: Site.IN_YOUR_AREA,
  siteSpecificClassName: "wraparound-iya",
  scaleContent: false,
  allowBackgroundColour: true,
};

const siteDependenciesIYA = {
  getBreakpoint: window.getBreakpoint,
  isDesktopBreakpoint: () => window.getBreakpoint() === "desktop",
  isMobileBreakpoint: () => window.getBreakpoint() === "mobile",
  isTabletLandscapeBreakpoint: () => {}, // not used on IYA
  isTabletPortraitBreakpoint: () => {}, // not used on IYA
  getPageType: () => {}, // not used on IYA
  nodeListToArray: () => {}, // not used on IYA
};

function receiveMessage(e) {
  let { data } = e;
  if (e.origin !== location.origin || !data) {
    return;
  }
  logFeature("msg", `[INFO] secure message received: ${data}`);

  try {
    data = JSON.parse(data);
  } catch (err) {
    logFeature("msg", `[WARN] message could not be parsed: ${data}`);
    return;
  }

  const advert = nested.get(data, "advert");

  if (advert?.format === "wraparound") {
    wraparoundNew.init(siteDependenciesIYA, siteConfigIYA);
    wraparoundNew.start(advert);
  }
}

function bindStartupEvents() {
  window.addEventListener("message", receiveMessage);
  // we dont use this event on IYA
  // events.listen(window, "wraparoundNew.load", (e) =>
  //   wraparoundNew.init(e?.data, siteConfig)
  // );
}

function start() {
  initCustomDOMEvents();
  bindStartupEvents();
  window.wraparoundAd = {
    cleanUp: wraparoundNew.reset,
  };
}

start();
